/**
 * Methods to detect browser features.
 *
 * @since 0.1.0
 */

export function webgl() {
  try {
    const canvas = document.createElement('canvas');

    return Boolean(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
  } catch (error) {
    return false;
  }
}


export function ie() {
  return Boolean(navigator.userAgent.match(/Trident|MSIE|Edge/gi));
}
